import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LEGO_CONSTANTS } from 'constants/index';
import { resolveRouteChangeMeta } from 'utils/routeChangeMeta';
import useMessageChannelAdapter from './use-message-channel-adapter';

export const useRouteChangeEventChannelEmitter = (emitOnMount = true, meta = null) => {
  const location = useLocation();
  const { emitRouteChangeEvent: emitRouteChangeEventMC } = useMessageChannelAdapter();

  const emitRouteChangeEvent = useCallback(
    (newRoute, metaOverride) => {
      const source = newRoute ?? location.pathname;
      const resource = String(source).replace(LEGO_CONSTANTS.ROUTE_PREFIX, '');
      const context = { resource };
      const resolvedMeta = resolveRouteChangeMeta(resource, metaOverride ?? meta);
      if (resolvedMeta) context.meta = resolvedMeta;
      emitRouteChangeEventMC(context);
    },
    [location.pathname, emitRouteChangeEventMC, meta]
  );

  useEffect(() => {
    if (emitOnMount) {
      emitRouteChangeEvent();
    }
  }, [emitOnMount, emitRouteChangeEvent]);

  return { emitRouteChangeEvent };
};
